import axios from "axios";

export const getOneByRef = async(props) => {
    let result = [];
    // console.log(props);

    const { ref, apiName } = props;

    const url = process.env.REACT_APP_BASE_URL + `/api/${apiName}?refBancaria=${ref}`;

    await axios.get(url)
    .then((response) => {
        const data = response.data;
        result = { ...data };
        if (data.exito === 1) {
            console.log("registro recuperado...");
        }
    });

    return result;
};
